import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import { firestore, useUser } from "../firebase";
import { hashOption, hashText, fields } from "../schema";
import { matchAllText } from "../utils";

import SearchBox from "../components/SearchBox";
import UserPreview from "../components/UserPreview";
import LoadingCard from "../components/LoadingCard";
import DangerAlert from "../components/DangerAlert";

const parseSearch = searchURI => {
  const searchParams = new URLSearchParams(searchURI);
  const res = {};
  searchParams.forEach((v, key) => {
    res[key] = decodeURIComponent(v);
  });
  return res;
};

const constructQuery = search => {
  var query = firestore().collection("users");
  // query = query.where("verified", "==", true);
  if ("kvisYear" in search) {
    query = query.where("kvisYear", "==", search.kvisYear);
  }
  fields.forEach(field => {
    const res = field.isText
      ? hashText(search[field.name])
      : hashOption(field.options, search[field.name]);
    if (res[0]) {
      query = query.where(`${field.prefix}${res[0]}`, "==", true);
    }
  });

  return query;
};

const userMatch = (user, search) => {
  const match = {
    name: !("name" in search),
    country: !("country" in search),
    state: !("state" in search),
    uniName: !("uniName" in search),
    degree: !("degree" in search),
    major: !("major" in search),
    scholarship: !("scholarship" in search),
    jobTitle: !("jobTitle" in search),
    employer: !("employer" in search),
    jobField: !("jobField" in search)
  };

  if (!match.name) {
    match.name = matchAllText(user.name, search.name);
  }

  if (user.education) {
    user.education.forEach(e => {
      if (!match.country) {
        if (!match.state) {
          match.country = match.state =
            e.country === search.country && e.state === search.state;
        } else {
          match.country = e.country === search.country;
        }
      }
      if (!match.uniName)
        match.uniName = matchAllText(e.uniName, search.uniName);
      if (!match.degree) match.degree = e.degree === search.degree;
      if (!match.major) match.major = matchAllText(e.major, search.major);
      if (!match.scholarship)
        match.scholarship = matchAllText(e.scholarship, search.scholarship);
    });
  }
  if (user.career) {
    user.career.forEach(c => {
      if (!match.country) {
        if (!match.state) {
          match.country = match.state =
            c.country === search.country && c.state === search.state;
        } else {
          match.country = c.country === search.country;
        }
      }
      if (!match.jobTitle)
        match.jobTitle = matchAllText(c.jobTitle, search.jobTitle);
      if (!match.employer)
        match.employer = matchAllText(c.employer, search.employer);
      if (!match.jobField) match.jobField = search.jobField === c.jobField;
    });
  }

  return !Object.entries(match).some(m => m[1] === false);
};

const Search = ({ location, history }) => {
  const { user } = useUser();
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState({});
  const [error, setError] = useState(false);
  useEffect(
    () => {
      setLoading(true);
      setError(false);
      const search = parseSearch(location.search);
      if (location.search) {
        const query = constructQuery(search);
        query
          .get()
          .then(querySnapshot => {
            const res = [];
            querySnapshot.forEach(doc => {
              const data = { ...doc.data(), id: doc.id };
              if (userMatch(data, search)) {
                res.push(data);
              }
            });
            setResult(res);
            setError(false);
            setLoading(false);
          })
          .catch(err => {
            console.log(err);
            setError(true);
            setLoading(false);
          });
      }
      setSearch(search);
    },
    [location.search, user]
  );

  if (!location.search) {
    history.push("/");
  }

  const summary =
    result.length === 0
      ? "no match"
      : result.length === 1
      ? "1 match"
      : `${result.length} matches`;

  return (
    <Container>
      <Row className="py-4">
        <Col lg={4} className="mb-3">
          <SearchBox values={search} />
        </Col>
        <Col lg={8} className="mb-3">
          {loading ? (
            <div>
              <h3 className="mb-3">Results</h3>
              <LoadingCard className="result-skeleton mb-3" />
              <LoadingCard className="result-skeleton mb-3" />
            </div>
          ) : error ? (
            <div>
              <h3 className="mb-3">Permission Denied</h3>
              <DangerAlert />
            </div>
          ) : (
            <div>
              <h3 className="mb-3">{`Results (${summary})`}</h3>
              {result.map(doc => {
                return <UserPreview key={doc.id} doc={doc} />;
              })}
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(Search);
